var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applicant-info"},[_c('el-descriptions',{attrs:{"column":2,"border":"","size":"small"}},[_c('el-descriptions-item',{attrs:{"label":"申请人"}},[_vm._v(_vm._s(_vm.displayName))]),_c('el-descriptions-item',{attrs:{"label":"部门"}},[_vm._v(_vm._s(_vm.displayDept))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }